export const SA_GET_PRODUCTS_LISTING = "SA_GET_PRODUCTS_LISTING"
export const SA_GET_PRODUCTS_LISTING_SUCCESS = "SA_GET_PRODUCTS_LISTING_SUCCESS"
export const SA_GET_PRODUCTS_LISTING_FAILED = "SA_GET_PRODUCTS_LISTING_FAILED"

export const SA_PRODUCT_EDIT = "SA_PRODUCT_EDIT"
export const SA_PRODUCT_EDIT_SUCCESS = "SA_PRODUCT_EDIT_SUCCESS"
export const SA_PRODUCT_EDIT_FAIL = "SA_PRODUCT_EDIT_FAIL"
